import { IRowNode } from 'ag-grid-community'

export const getTopLevelNodes = (nodes: IRowNode[]): IRowNode[] => {
  const topLevelNodes: IRowNode[] = []
  const sortedNodes = nodes.sort((a, b) => a.level - b.level)
  for (let node of sortedNodes) {
    // TODO: ★Check
    const isChildOfSome = topLevelNodes.some(
      topLevelNode => topLevelNode.parent === node
    )
    if (!isChildOfSome) {
      topLevelNodes.push(node)
    }
  }
  return topLevelNodes
}

export const sortByRowIndex = (nodes: IRowNode[]): IRowNode[] => {
  return nodes.sort((a, b) => (a.rowIndex || 0) - (b.rowIndex || 0))
}
